<script>
export default {
  name: 'icon-edit',
  props: {
    color: {
      default: () => {
        return 'white'
      },
      type: String,
    },
  },
}
</script>

<template>
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 20.5841V26H5.41591L21.3893 10.0267L15.9733 4.61075L0 20.5841ZM25.5776 5.83836C26.1408 5.2751 26.1408 4.36523 25.5776 3.80197L22.198 0.422441C21.6348 -0.140814 20.7249 -0.140814 20.1616 0.422441L17.5187 3.06541L22.9346 8.48132L25.5776 5.83836Z"
      :fill="color"
    />
  </svg>
</template>
